import React from 'react'

export default function DetalleProductosCondicionales (props) {
  const { detalleProductos, totalProductos, tituloTotal } = props

  return (
    <div style={{
      display: 'flex',
      flexCirection: 'row',
      justifyContent: 'center',
      alignItems: 'flex-end'
    }}
    >
      { detalleProductos ? <> {detalleProductos()} </> : <></> }
      { totalProductos &&
      <h5 style={{ fontSize: '1.1rem', margin: 0 }}>
        {tituloTotal} : <b>{totalProductos}</b>
      </h5>
      }
    </div>
  )
}
